var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCaja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.963 307.224C134.937 322.419 149.424 330 165 330V165.198L10.527 84L9.867 85.1042C9.83477e-07 101.815 0 122.63 0 164.242V166.17C0 207.766 -1.96695e-06 228.581 9.8505 245.292C19.7175 262.019 37.4715 271.33 72.963 289.937L105.963 307.224Z",
    fill: "#81B193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M256.739 40.128L223.84 22.803C194.971 7.6065 180.528 0 165 0C149.455 0 135.029 7.59 106.144 22.803L73.2448 40.128C38.6351 58.344 20.9355 67.65 11 83.688L165 165L319 83.7045C309.032 67.65 291.365 58.344 256.739 40.128Z",
    fill: "#81B193"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.149 85.1042L319.473 84L165 165.198V330C180.576 330 195.063 322.419 224.037 307.224L257.037 289.92C292.528 271.314 310.282 262.019 320.149 245.292C330 228.581 330 207.766 330 166.187V164.259C330 122.646 330 101.815 320.149 85.1042Z",
    fill: "#036428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.234 40.8027L72.8856 39.9442L97.543 27L247.833 109.635L314.307 76.4323C316.564 78.9859 318.557 81.7267 320.286 84.6545C322.763 88.8482 324.613 93.306 326 98.2757L259.955 131.28V181.406C259.955 184.69 258.65 187.84 256.327 190.162C254.004 192.484 250.854 193.789 247.569 193.789C244.283 193.789 241.133 192.484 238.81 190.162C236.487 187.84 235.182 184.69 235.182 181.406V143.663L177.378 172.556V328.415C173.333 329.463 169.171 329.996 164.992 330C160.896 330 156.85 329.472 152.605 328.415V172.556L4 98.2592C5.38729 93.306 7.23701 88.8482 9.71431 84.6545C11.4319 81.7267 13.4248 78.9859 15.6929 76.4323L164.992 151.06L220.929 123.107L71.234 40.8027Z",
    fill: "#00725E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaja);
export default __webpack_public_path__ + "static/media/ic_caja.eb6cc5ecdbe2c950172bf7c93c0bf557.svg";
export { ForwardRef as ReactComponent };